import React from 'react'
import cn from 'classnames'
import { useInfiniteQuery } from 'react-query'
import { useRouter } from 'next/router'

import { ChapterStatusEnum } from '@interfaces/ChapterStatusEnum'
import { useAuthentication } from '@hooks/useAuthentication'
import { useTheme } from '@hooks/contexts/ThemeContext/ThemeContext'
import { useChapterAction } from '@hooks/chapter/useChapterAction'
import { Loading } from '@components/Loading'
import { SelectChapterForReaderProps } from './interface'
import { SelectChapter } from '../SelectChapter'

const limit = 12

export function SelectChapterForReader({
  bookId,
}: SelectChapterForReaderProps) {
  const router = useRouter()
  const chapterClient = useChapterAction()
  const { canFetchApi } = useAuthentication()
  const { isDarkTheme, isNightTheme, isLightTheme, isSepiaTheme } = useTheme()

  const { fetchNextPage, data, isFetchingNextPage } = useInfiniteQuery(
    ['books', bookId, 'table-contents'],
    async ({ pageParam = 1 }) => {
      const res = await chapterClient.getTableContenReadertList(
        bookId,
        pageParam,
        limit
      )

      return res
    },
    {
      getNextPageParam: (lastPage: any) => {
        if (lastPage.chapters.length) return lastPage.page + 1

        return undefined
      },
      enabled: canFetchApi,
    }
  )

  return (
    <SelectChapter
      onScroll={(e: any) => {
        const scrollHeight = e.target.scrollHeight - 10
        const scrollTop = e.target.scrollTop + e.target.offsetHeight
        if (scrollHeight <= scrollTop && !isFetchingNextPage) {
          fetchNextPage()
        }
      }}
    >
      {data?.pages.map(page =>
        page.chapters?.map(chapter => {
          const disable =
            chapter.status === ChapterStatusEnum.RESTRICTED && !chapter.isPaid

          return (
            <div
              key={chapter.id}
              className={cn({
                'cursor-pointer': !disable,
                'cursor-not-allowed': disable,
              })}
              onClick={() => {
                if (disable) {
                  return
                }

                router.push(`/story/${bookId}/chapter/${chapter.id}`)
              }}
            >
              <SelectChapter.Item
                isDarkTheme={isDarkTheme}
                isNightTheme={isNightTheme}
                isLightTheme={isLightTheme}
                isSepiaTheme={isSepiaTheme}
              >
                {chapter.chapterTitle} {chapter.chapterName}
              </SelectChapter.Item>
            </div>
          )
        })
      )}
      {isFetchingNextPage && <Loading className='mx-auto' size={20} />}
    </SelectChapter>
  )
}
